import MessageCenterWidget from './MessageCenterWidgetContainer';

export default MessageCenterWidget;